import * as angular from "angular";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";
import {DataStoreConfig} from "../persistence-layer/models/datastore-config.model";

angular
  .module('bringoz.admin.deliveries')
  .factory('$deliveriesMessages', deliveriesMessagesObjectFactory);

/* @ngInject */
function deliveriesMessagesObjectFactory($bringozFactory: $bringozFactory,
                                         DeliveriesMessagesAPI: BringozApi,
                                         Deliveries_Messages_DS: DataStoreConfig) {

  function $deliveriesMessages(id: string) {
    return $bringozFactory(id, DeliveriesMessagesAPI, Deliveries_Messages_DS)
  }
  return $deliveriesMessages
}
